import { useState } from "react";
import { VultMark } from "./Logo";
import { toast } from "sonner";
import { Send } from "lucide-react";

export function Footer() {
  const [email, setEmail] = useState("");
  return (
    <footer className="relative overflow-hidden bg-slate-950 pt-20 text-white">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="grid grid-cols-1 gap-12 pb-16 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <VultMark size={34} />
              <span className="font-display text-2xl font-black italic tracking-tight text-white">VULT<span className="text-vult-red">.</span></span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Curadoria de sneakers das maiores marcas do mundo. Drop raro, entrega rápida e qualidade altíssima.
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["PIX"].map((p) => (
                <span key={p} className="rounded-full border border-slate-700 px-3 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-slate-300">{p}</span>
              ))}
            </div>
          </div>
          <div>
            <div className="font-mono text-xs font-bold uppercase tracking-widest text-vult-lime">Navegação</div>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
              {[["Lançamentos", "#catalogo"], ["Marcas", "#marcas"], ["Categorias", "#categorias"], ["Ofertas", "#catalogo"], ["Painel Admin", "/admin"]].map(([l, h]) => (
                <li key={l}><a href={h} className="transition-colors hover:text-white">{l}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <div className="font-mono text-xs font-bold uppercase tracking-widest text-vult-lime">Fique por dentro dos drops</div>
            <p className="mt-4 text-sm text-slate-400">Receba primeiro os lançamentos e cupons exclusivos.</p>
            <form
              className="mt-4 flex gap-2"
              onSubmit={(e) => { e.preventDefault(); if (email) { toast.success("Inscrito! Fique de olho no seu e-mail."); setEmail(""); } }}
            >
              <input
                data-testid="vult-footer-newsletter-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="seu@email.com"
                className="flex-1 rounded-full border border-slate-700 bg-transparent px-4 py-2.5 text-sm text-white outline-none placeholder:text-slate-500 focus:border-vult-lime"
              />
              <button data-testid="vult-footer-newsletter-btn" className="flex h-11 w-11 items-center justify-center rounded-full bg-vult-red text-slate-900 transition-colors hover:bg-slate-900 hover:text-white">
                <Send size={16} />
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="pointer-events-none select-none overflow-hidden text-center font-display text-[22vw] font-black italic leading-[0.75] text-stroke-ghost">
        VULT
      </div>
      <div className="border-t border-slate-800 py-5 text-center font-mono text-[10px] font-bold uppercase tracking-widest text-slate-500">
        © 2026 Vult Sneakers — Todos os direitos reservados
      </div>
    </footer>
  );
}
